import styled from "styled-components";
import { ReactComponent as LogoUser } from '../../../assets/svg/user.svg';
import { COLORS } from "../../../constants";
import store from "../../../_services/store";
import userLabels from '../../../_translations/inscription.json';
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";

const UserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 16px;
  right: 16px;
`;

const Label = styled.span`
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  margin-left: 10px;
  color: ${COLORS.WHITE};
`;

const UserBadge = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (store.user) {
      navigate(ROUTES.PROFILE());
    }
    else {
      navigate(ROUTES.PROFILE());
      // navigate(ROUTES.LOGIN());
    }
  }

  return (
    <UserContainer onClick={handleClick}>
      <Label>{store.user?.first_name || userLabels[store.currentLanguage].loggintitle}</Label>
      <LogoUser className="onHover" style={{ borderRadius: '50%' }} fill={COLORS.PRIMARY} />
    </UserContainer>
  )
}

export default UserBadge;